import { gsap } from "gsap";

export default class AccordionHandler {
	init() {
		const accordions = gsap.utils.toArray('[data-accordion="container"]');
		
		accordions.forEach((accordion, index) => {
			const trigger = accordion.querySelector('[data-accordion="trigger"]');
			const content = accordion.querySelector('[data-accordion="content"]');
			if (index === 0) {
				accordion.classList.add('is-active');
				gsap.set(accordion, { height: trigger.offsetHeight + content.scrollHeight });
			} else {
				accordion.style.height = `${trigger.offsetHeight}px`;
			}
	
			trigger.addEventListener('click', () => {
				const isActive = accordion.classList.contains('is-active');
				accordion.classList.toggle('is-active');
	
				const targetHeight = isActive
					? trigger.offsetHeight
					: trigger.offsetHeight + content.offsetHeight;
	
				gsap.to(accordion, { height: targetHeight, duration: 0.5, ease: 'power4.out' });
			});
		});
	
		function updateAccordionHeight(accordion) {
			const trigger = accordion.querySelector('[data-accordion="trigger"]');
			const content = accordion.querySelector('[data-accordion="content"]');
			const isActive = accordion.classList.contains('is-active');
			const targetHeight = isActive 
				? trigger.offsetHeight + content.scrollHeight
				: trigger.offsetHeight;
			gsap.set(accordion, { height: targetHeight });
		}
		window.addEventListener('resize', () => accordions.forEach(updateAccordionHeight));
	}
}